import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';

export const Cuerpo = ({ data, children }) => {
  const sucursalesSolicitadas =
    data.solicitado.sucursales
      .map(sucursal => sucursal.nombreSucursal)
      .join(', ') || '';

  return (
    <div className="bg-white rounded shadow-md p-4 pb-24 sm:px-10 sm:pt-10 relative mb-16">
      <div className="w-full md:w-4/5 mb-10">
        <Heading type="h2">Conceder acceso de administración</Heading>
        <Text size="M">
          El usuario <strong>{data.solicitante.nombreUsuario}</strong> del
          negocio <strong>{data.solicitante.nombreEmpresa}</strong> ha
          solicitado poder administrar la/s sucursal/es{' '}
          <strong>{sucursalesSolicitadas}</strong> de tu negocio.
        </Text>
      </div>
      {children}
    </div>
  );
};
